module.exports = __webpack_public_path__ + "static/fast-speeds-0af1b06a63ce3a9f1fb10a205b46ab1e.png";